import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { texts } from 'utils/languages/fr';

import { ConfirmDialog, CustomFormLabel, FileErrorMessage, FileInputButton } from 'components';
import { Box, Button, Link, Typography } from '@mui/material';

const FileName = ({ file, name }) =>
    file?.url ? (
        <Link
            variant="body2"
            sx={{ flex: '1 1 65%' }}
            textOverflow="ellipsis"
            noWrap
            title={file?.name}
            gutterBottom
            target="_blank"
            href={file?.url}
        >
            {name}
        </Link>
    ) : (
        <Typography
            variant="body2"
            sx={{ flex: '1 1 65%' }}
            textOverflow="ellipsis"
            noWrap
            title={name}
            gutterBottom
        >
            {name}
        </Typography>
    );

FileName.propTypes = {
    file: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    name: PropTypes.string,
};

const FundFile = props => {
    const {
        onChange,
        onDelete,
        id,
        name,
        sizeError,
        typeError,
        label,
        file,
        containerSx,
        ...rest
    } = props;
    const [deleteFileOpen, setDeleteFileOpen] = useState(false);

    return (
        <Box
            sx={{ width: '100%', ...containerSx }}
            display="flex"
            justifyContent="center"
            flexDirection="column"
            alignItems="flex-start"
        >
            <CustomFormLabel>{label}</CustomFormLabel>
            <Box width="100%" display="flex" justifyContent="space-between" alignItems="center">
                {(file?.url || file?.name) && <FileName file={file} name={name} />}
                <Box sx={{ textAlign: 'right' }}>
                    <FileInputButton
                        id={id}
                        {...rest}
                        noMargin
                        showIcon
                        onFileChange={onChange}
                        label={texts.UPLOAD_FILE_BUTTON}
                    />
                    {file?.url && onDelete && (
                        <Button onClick={() => setDeleteFileOpen(true)}>{texts.SUPPRIMER}</Button>
                    )}
                    {file?.url && onDelete && (
                        <ConfirmDialog
                            open={deleteFileOpen}
                            title={texts.SUPPRIMER}
                            handleClose={() => setDeleteFileOpen(false)}
                            handleConfirm={onDelete}
                        >
                            {texts.ETES_VOUS_SURS_DE_VOULOIR_SUPPRIMER}
                        </ConfirmDialog>
                    )}
                </Box>
            </Box>
            {typeError && <FileErrorMessage useMargin={false} variant="type" />}
            {sizeError && <FileErrorMessage useMargin={false} variant="size" />}
        </Box>
    );
};

FundFile.propTypes = {
    onChange: PropTypes.func,
    onDelete: PropTypes.func,
    id: PropTypes.string,
    name: PropTypes.string,
    sizeError: PropTypes.bool,
    typeError: PropTypes.bool,
    label: PropTypes.string,
    file: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    containerSx: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
};

export default FundFile;
